import { StyleSheet} from 'aphrodite';
export const styles = StyleSheet.create({
    card : {
        backgroundColor: "#fff",
        borderRadius: 5,
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        transition: "all 0.3s cubic-bezier(.25,.8,.25,1)",
        ":hover": {
            boxShadow: "0 10px 20px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)"
        }
    },

    card_header : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 0,
    },
        
    card_label: {
        marginLeft: 25,
        marginTop: 15,
        marginBottom: 15,
        fontSize: 16,
        color: "#5a5a5aff"
    },

    download_icon: {
        marginLeft: "auto",
        marginRight: 20,
        color: "#5a5a5aff",
        ":hover": {
            cursor: "pointer",
            color: "#006bcfff"
        }
    },

    seperator: {
        backgroundColor: "#d2d2d2ff",
        height: 1
    },
    
    empty_view: {
        padding: 100,
    },

    trend_bar_hover: {
        ":hover" :{
            cursor: "pointer",
            backgroundColor: "yellow"           
        }
    },
    
    trend_container: {
        flex: 8,
        display: "flex",
        flexDirection: "column",
        minHeight: 300,
        maxHeight: 300
    },

    trend_chart_container: {
        height: 280,
        marginTop: 10,
        display: "flex",
        alignItems: "center",
        padding: "0.05rem",
        backgroundColor: 'white'
    },

    icons : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 20,
        marginRight: 10,
    },

    icon: {
        marginLeft: 10,
        marginRight: 10,
        color: "#5a5a5aff",
        ":hover": {
            cursor: "pointer",
            color: "#006bcfff"
        }
    },

    selectionView: {
        marginLeft: "auto",
        display: "grid",
        gridTemplateColumns: "auto auto",
        gridColumnGap: "10px",
        alignItems: 'center'
    },

    tooltip: {
        padding: "10px",
        backgroundColor: "white",
        borderRadius: "5px",
        borderColor: "#d1d1d1",
        borderStyle: "solid",
        borderWidth: "1px"

    },
    
    toggleViewContainer : {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },

    toggleLabel: {
        marginLeft: "0px"
    },

    toggleIconOn: {
        marginLeft: 10,
        marginRight: 10,
        fontSize: "22px",
        color: "#006bcfff",
        ":hover": {
            cursor: "pointer",
            color: "#006bcfff"
        }
    },

    toggleIconOff: {
        marginLeft: 10,
        marginRight: 10,
        fontSize: "22px",
        color: "#5a5a5aff",
        ":hover": {
            cursor: "pointer",
            color: "#006bcfff"
        }
    },

    range: {
        display: "grid",
        gridTemplateColumns: "min-content min-content min-content",
        gridTemplateColumnGap: "0px",
        alignItems: "center",
        color: "#5a5a5aff",
        marginLeft: "0px"
    },

    date: {
        "white-space": "nowrap",
        padding: "5px"
    },

    dropdown: {
        position: "relative",
        display: "inline-block",
        "z-index": "1",
    },

    dropdown_content: {
        position: "absolute",
        backgroundColor: "#f1f1f1",
        "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)",
    },

})


// WEBPACK FOOTER //
// ./src/styles/TrendChart.ts